import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { SsoCallbackComponent } from './pages/sso-callback/sso-callback.component';

export const AuthRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'register',
    component: LoginComponent,
  },
  {
    path: 'sso',
    children: [
      {
        path: 'callback',
        component: SsoCallbackComponent,
      },
    ],
  },
];
